<template>
  <div id="app" ref="container" class="navbar">
<!--    <el-button @click="showNotificationBar('test', false)">ces</el-button>-->
    <notice-bar ref="notification" />
    <audio ref="audio" preload="metadata" hidden src="@/audio/notify1.mp3" />
    <router-view />
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
import notification from 'notification-koro1'
import Watermark from '@/utils/waterMarks'
import NoticeBar from "@/components/NoticeBar/index.vue";
// import Vue from 'vue' // 引入npm包
const NotificationClass = new notification('订单系统', { body: '系统通知开启' }) // 初始化

export default {
  name: 'App',
  components: {
    NoticeBar
  },
  created() {
    // 因为我的页面有缓存机制，用户下次有可能直接打开某个登录后才能访问的页面 比如F5刷新了某个页面 需要重连
    // 又比如后端服务器因为什么原因突然中断了一下 也需要重新连接WebSocket
    // 每3秒检测一次websocket连接状态 未连接 则尝试连接 尽量保证网站启动的时候 WebSocket都能正常长连接
    this.initnotify()
    setInterval(this.WebSocket_StatusCheck, 10000)
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') {
      const name =
        localStorage.getItem('userInfo') &&
        JSON.parse(localStorage.getItem('userInfo')).name
      Watermark.set('测试版', this.$refs.container)
    }
  },
  methods: {
    showNotificationBar(msg,glowing) {
      this.$refs.notification.showNotification(msg,glowing);
    },
    initnotify() {
      if (NotificationClass.support) {
        // 显示通知逻辑，以下所有步骤都要在这里调用
        NotificationClass.initNotification(this.userSelectFn)
      } else {
        // 浏览器不支持
      }
    },
    userSelectFn(msg) {
      if (msg === 'already granted' || msg === 'granted') {
        // 随时可以调用通知
        return NotificationClass.userAgreed()
      } else if (msg === 'close') {
        // 请求权限通知被关闭
        return NotificationClass.initNotification(this.userSelectFn) // 再次调用
      } else if (msg === 'denied' || msg === 'already denied') {
        // 请求权限当前被拒绝 || 曾经被拒绝
        if (msg === 'denied') {
          console.log('您刚刚拒绝显示通知 请在设置中更改设置')
        } else {
          console.log('您曾级拒绝显示通知 请在设置中更改设置')
        }
      }
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
    showGobalNotify(msg) {
      if (!document.hasFocus()) {
        var notification = new Notification('订单系统消息', { body: msg })
      }
      this.$notify.info({
        title: '系统消息',
        message: msg,
        duration: 10 * 1000
      })
      this.$refs.audio.currentTime = 0
      this.$refs.audio.play() // 播放
    },

    // 1、WebSocket连接状态检测：
    WebSocket_StatusCheck() {
      if (typeof getToken() !== 'undefined') {
        // console.log(getToken())
        if (!this.$WebSocket.WebSocketHandle || this.$WebSocket.WebSocketHandle.readyState !== 1) {
          this.WebSocketINI()
        }
      }
    },

    // 2、WebSocket初始化：
    async WebSocketINI() {
      // 1、浏览器是否支持WebSocket检测
      if (!('WebSocket' in window)) {
        console.log('您的浏览器不支持WebSocket!')
        return
      }

      const tmpWebsocketSrverAddress = process.env.VUE_APP_BASE_WS
      // 3、创建Websocket连接
      const tmpWebsocket = new WebSocket(tmpWebsocketSrverAddress)
      // tmpWebsocket.send(getToken())
      // 4、全局保存WebSocket操作句柄：main.js 全局引用
      this.$WebSocket.WebsocketINI(tmpWebsocket)

      this.$WebSocket.WebSocketBandMsgReceivedEvent(e => {
        const message = JSON.parse(e.data)
        if (message.Type === 'SystemInfo') {
          this.showGobalNotify(message.Content)
        }else if (message.Type === 'Cheer') {
          this.showNotificationBar(message.Content,false)
        }else if (message.Type === 'SumPriceCheer') {
          this.showNotificationBar(message.Content, true)
        }else {
          this.showGobalNotify(message.Content)
        }
      })
      this.$WebSocket.SetAuthSuccess(flag => {
        if (flag) {
          this.$message({
            message: 'Websocket连接成功',
            type: 'success'
          })
        } else {
          this.logout()
        }
      })
      // 5、WebSocket连接成功提示
      tmpWebsocket.onopen = e => {
        tmpWebsocket.send(getToken())
      }

      // 6、连接失败提示
      tmpWebsocket.onclose = function(e) {
        this.$message({
          message: 'Websocket连接已断开',
          type: 'danger'
        })
      }
    }

  }
}
</script>
<style>
  .app-container{
    padding: 5px;
  }
  /*body .el-table th.gutter{*/
  /*  display: table-cell!important;*/
  /*}*/
</style>
